import api, { garcomApi } from './api';

export const authService = {
  login: (username, password) => api.post('/auth/login', { username, password }),
  me: () => api.get('/auth/me'),
};

export const produtosService = {
  listar: (params) => api.get('/produtos', { params }),
  buscar: (id) => api.get(`/produtos/${id}`),
  criar: (data) => api.post('/produtos', data),
  atualizar: (id, data) => api.put(`/produtos/${id}`, data),
};

export const categoriasService = {
  listar: () => api.get('/categorias'),
  criar: (data) => api.post('/categorias', data),
  atualizar: (id, data) => api.put(`/categorias/${id}`, data),
  remover: (id) => api.delete(`/categorias/${id}`),
};

export const pedidosService = {
  listar: (params) => api.get('/pedidos', { params }),
  buscar: (id) => api.get(`/pedidos/${id}`),
  criar: (data) => api.post('/pedidos', data),
  atualizarStatus: (id, status) => api.patch(`/pedidos/${id}/status`, { status }),
};

export const mesasService = {
  listar: () => api.get('/mesas'),
  consumo: (id) => api.get(`/mesas/${id}/consumo`),
  atualizarStatus: (id, status) => api.patch(`/mesas/${id}/status`, { status }),
  criar: (data) => api.post('/mesas', data),
};

export const displayService = {
  enviar: (comanda_id) => api.post('/display/comanda', { comanda_id }),
  enviarMesa: (mesa_id) => api.post('/display/mesa', { mesa_id }),
  enviarAvulso: (itens, total) => api.post('/display/avulso', { itens, total }),
  limpar: () => api.post('/display/comanda', { comanda_id: null }),
  pago: () => api.post('/display/pago'),
};

export const caixaService = {
  atual: () => api.get('/caixa/atual'),
  abrir: (saldo_inicial) => api.post('/caixa/abrir', { saldo_inicial }),
  fechar: (data) => api.post('/caixa/fechar', data),
  sangria: (data) => api.post('/caixa/sangria', data),
  suprimento: (data) => api.post('/caixa/suprimento', data),
  pagamento: (data) => api.post('/caixa/pagamento', data),
  pagarMesa: (data) => api.post('/caixa/pagamento-mesa', data),
};

export const estoqueService = {
  listar: () => api.get('/estoque'),
  listarInativos: () => api.get('/estoque/insumos/inativos'),
  criarInsumo: (data) => api.post('/estoque/insumos', data),
  atualizarInsumo: (id, data) => api.put(`/estoque/insumos/${id}`, data),
  ocultarInsumo: (id) => api.patch(`/estoque/insumos/${id}/ocultar`),
  reativarInsumo: (id) => api.patch(`/estoque/insumos/${id}/reativar`),
  movimentacao: (data) => api.post('/estoque/movimentacao', data),
  movimentacoes: (insumoId) => api.get(`/estoque/movimentacoes/${insumoId}`),
  listarLotes: (insumoId) => api.get(`/estoque/lotes/${insumoId}`),
  criarLote: (data) => api.post('/estoque/lotes', data),
  atualizarLote: (id, data) => api.put(`/estoque/lotes/${id}`, data),
};

export const insumoCategoriasService = {
  listar: () => api.get('/insumo-categorias'),
  criar: (data) => api.post('/insumo-categorias', data),
  atualizar: (id, data) => api.put(`/insumo-categorias/${id}`, data),
  remover: (id) => api.delete(`/insumo-categorias/${id}`),
};

export const fichasService = {
  buscar: (produto_id) => api.get(`/fichas/${produto_id}`),
  salvar: (data) => api.post('/fichas', data),
};

export const producaoService = {
  listar: (params = {}) => api.get('/producao', { params }),
  atualizarStatus: (id, status) => api.patch(`/producao/${id}/status`, { status }),
};

export const comandasService = {
  listar: (params) => api.get('/comandas', { params }),
  buscar: (id) => api.get(`/comandas/${id}`),
  criar: (data) => api.post('/comandas', data),
  adicionarItem: (id, data) => api.post(`/comandas/${id}/itens`, data),
  fechar: (id) => api.patch(`/comandas/${id}/fechar`),
  pagar: (id, data) => api.patch(`/comandas/${id}/pagar`, data),
  cancelar: (id) => api.delete(`/comandas/${id}`),
  cancelarItem: (comandaId, itemId) => api.delete(`/comandas/${comandaId}/itens/${itemId}`),
  buscarPorNumero: (numero) => api.get('/comandas', { params: { numero, status: 'aberta' } }),
  cartoesEmUso: () => api.get('/comandas/cartoes-em-uso'),
};

export const clientesService = {
  listar: (busca) => api.get('/clientes', { params: busca ? { busca } : {} }),
  criar: (data) => api.post('/clientes', data),
  atualizar: (id, data) => api.put(`/clientes/${id}`, data),
  remover: (id) => api.delete(`/clientes/${id}`),
};

export const fiadosService = {
  listar: () => api.get('/fiados'),
  porCliente: (id) => api.get(`/fiados/cliente/${id}`),
  pagar: (id, data) => api.post(`/fiados/${id}/pagar`, data),
};

export const financeiroService = {
  resumo: (mes) => api.get('/financeiro/resumo', { params: { mes } }),
  contas: (params) => api.get('/financeiro/contas', { params }),
  criarConta: (data) => api.post('/financeiro/contas', data),
  pagarConta: (id) => api.patch(`/financeiro/contas/${id}/pagar`),
  dre: (mes) => api.get('/financeiro/dre', { params: { mes } }),
  caixasDia: (data) => api.get('/financeiro/caixas-dia', { params: { data } }),
};

export const relatoriosService = {
  vendasPeriodo: (params) => api.get('/relatorios/vendas-periodo', { params }),
  topProdutos: (limite) => api.get('/relatorios/top-produtos', { params: { limite } }),
  vendasFormaPagamento: () => api.get('/relatorios/vendas-forma-pagamento'),
  vendasColaborador: () => api.get('/relatorios/vendas-colaborador'),
  entregasEntregador: () => api.get('/relatorios/entregas-entregador'),
  clientesFrequentes: () => api.get('/relatorios/clientes-frequentes'),
  categorias: () => api.get('/relatorios/categorias'),
  dashboard: (params = {}) => api.get('/relatorios/dashboard', { params }),
};

export const usuariosService = {
  listar: () => api.get('/usuarios'),
  criar: (data) => api.post('/usuarios', data),
  atualizar: (id, data) => api.put(`/usuarios/${id}`, data),
  perfis: () => api.get('/usuarios/perfis'),
};

export const ativosService = {
  listar: (params) => api.get('/ativos', { params }),
  criar: (data) => api.post('/ativos', data),
  atualizar: (id, data) => api.put(`/ativos/${id}`, data),
  remover: (id) => api.delete(`/ativos/${id}`),
  listarAnexos: (id) => api.get(`/ativos/${id}/anexos`),
  enviarAnexo: (id, formData) => api.post(`/ativos/${id}/anexos`, formData),
  baixarAnexo: (anexoId) => api.get(`/ativos/anexos/${anexoId}/download`, { responseType: 'blob' }),
  removerAnexo: (anexoId) => api.delete(`/ativos/anexos/${anexoId}`),
};

export const ativoCategoriasService = {
  listar: () => api.get('/ativo-categorias'),
  criar: (data) => api.post('/ativo-categorias', data),
  atualizar: (id, data) => api.put(`/ativo-categorias/${id}`, data),
  remover: (id) => api.delete(`/ativo-categorias/${id}`),
};

export const configService = {
  clientes: (params) => api.get('/config', { params }),
  criarCliente: (data) => api.post('/config', data),
  atualizarCliente: (id, data) => api.put(`/config/${id}`, data),
  empresa: () => api.get('/config/empresa'),
  atualizarEmpresa: (data) => api.put('/config/empresa', data),
  taxasCartao: () => api.get('/config/taxas-cartao'),
  atualizarTaxasCartao: (taxas) => api.put('/config/taxas-cartao', { taxas }),
  configDelivery: () => api.get('/config/config-delivery'),
  atualizarConfigDelivery: (data) => api.put('/config/config-delivery', data),
};

export const cardapioService = {
  listar: () => api.get('/cardapio'),
  fazerPedido: (data) => api.post('/cardapio/pedido', data),
  mesaPedido: (data) => api.post('/cardapio/mesa-pedido', data),
};

export const garcomService = {
  login: (username, password) => api.post('/garcons/login', { username, password }),
  listar: () => api.get('/garcons'),
  criar: (data) => api.post('/garcons', data),
  atualizar: (id, data) => api.put(`/garcons/${id}`, data),
  // Rotas via garcom_token
  listarMesas: () => garcomApi.get('/mesas'),
  listarCardapio: () => garcomApi.get('/cardapio'),
  listarComandas: (mesa_id) => garcomApi.get('/comandas', { params: { mesa_id, status: 'aberta' } }),
  criarComanda: (data) => garcomApi.post('/comandas', data),
  cancelarComanda: (id) => garcomApi.delete(`/comandas/${id}`),
  adicionarItemComanda: (id, data) => garcomApi.post(`/comandas/${id}/itens`, data),
  cartoesEmUso: () => garcomApi.get('/comandas/cartoes-em-uso'),
};
